<template>
	<div>
		<div class="headers">
			<div class="headerleft">
              <!-- 面包屑 -->
                <el-breadcrumb class="breadcrumb-container" separator="/">
                    <!-- <el-breadcrumb-item :to="{ path: '/overview' }">店铺概览</el-breadcrumb-item> -->
                    <el-breadcrumb-item v-for="item in breadArr" :key="item.path" :to="item.route">{{item.title}}</el-breadcrumb-item>
                    <el-breadcrumb-item class="itemspan" v-if="coursename!=''">{{coursename}}</el-breadcrumb-item>
                    <el-breadcrumb-item class="itemspan" v-if="classname!=''">{{classname}}</el-breadcrumb-item>
                    <el-breadcrumb-item class="itemspan" v-if="specname!=''">{{specname}}</el-breadcrumb-item>
                </el-breadcrumb>
			</div>
			<div class="headerright">
                <div class="input-one"  v-if="Number(authlist.search)==1">
                   <el-input size="small" placeholder="请输入课程名称搜索" v-model="input2" @keypress.enter.native="sousuw"></el-input>
				  <img class="searchimg" src="../../assets/img/iconsearch.png" @click="sousuw" alt />
                </div>
                <span class="shugang"  v-if="Number(authlist.search)==1"></span>
                <div class="input-two">
                    <div class="input-button">
                       <el-button size="small" round>访问店铺</el-button>
                    </div>
                    <div class="erweima">
                     <span class="saoyisao">扫一扫访问</span>
                     <qriously class="erwei" :value="links" :size="98" />
                     <span class="fuzu" v-clipboard:copy="links" v-clipboard:success="copy">复制链接</span>
                    </div>
                </div>
                <span class="shugang"></span>
                <div class="tongzhicenter" v-if="Number(authlist.tongzhi)==1||Number(authlist.yijian)==1">
                   <div class="tonmain">
                       <span>通知中心</span>
					<i style="font-size:12px" class="el-icon-caret-bottom el-icon--right"></i>
                   </div> 
                   <div class="tongzhilist">
                     <el-button v-if="Number(authlist.yijian)==1" @click="handleCommand1">意见反馈</el-button>
					<el-button v-if="Number(authlist.tongzhi)==1" @click="pinlun">评论管理</el-button>
                   </div>
                </div>
                 <span class="shugang" v-if="Number(authlist.tongzhi)==1||Number(authlist.yijian)==1"></span>
				 <div class="tongzhicenter">
					 <div class="tonmain" @click="jumphelp">
						 <span>帮助中心</span>
					 </div>
				 </div>
				  <span class="shugang shugangmain" ></span>
                 <div class="person">
                     <div class="person-one">
                        <span>{{names}}</span>
                        <i style="font-size:12px" class="el-icon-caret-bottom el-icon--right"></i>
                     </div>
                     <div class="tuideng" @click="handleCommand">
                         退出登录
                     </div>
                 </div>
			</div>
		</div>
	</div>
</template>
<script>
	import Bus from "../../assets/js/bus.js";
	export default {
		data() {
			return {
				input2: "",
				links: '',
				url: this.$store.state.p_url,
				imgUrl: this.$store.state.img_url,
				names: window.sessionStorage.getItem('name'),
				authlist: {},
				breadArr: [], // 面包屑
				coursename:'',
				specname:'',
				classname:'',
			}
		},
		methods: {
			//
			jumphelp(){
               var that = this;
				var routeData = that.$router.resolve({
				    path: '/helpCenter',
				})
				window.open(routeData.href, '_blank');
			},
            //第一步
			getObj(val) {
				// console.log(val);
				this.breadArr = val;
				this.input2 = ''
            },
            //第二步//清除
			getBreadcrumb() { 
				// console.log(this.$route.matched)
				// if(this.$route.matched[1]){
				// 	if (this.$route.matched[1].name == "overview") {
				// 		this.breadArr = [];
				// 		Bus.$emit('shou', false); //发射
				// 	}
				// }
            },
            sousuw(){
                let that = this
				this.$router.push({
					path: '/evaluate?content=' + this.input2,
				})
            },
            //service/shopDecoration/link 链接
			link() {
				let that = this
				that.$axios.post(that.url + "service/shopDecoration/link").then(res => {
					if (res.data.code == 200 || res.data.code == '200') {
						that.links = res.data.data.link
					}
				})
            },
           //意见反馈
			handleCommand1() {
				this.$router.push({
					path: '/opinion',
				})
			},
			//评论管理
			pinlun() {
				this.$router.push({
					path: '/commentmanger',
				})
			},
            //service/auth/operateMenu 操作权限
			operateMenu() {
				let that = this
				that.$axios.post(that.url + "service/auth/operateMenu", '', {
					headers: {
						admin: window.sessionStorage.getItem('admin')
					}
				}).then(res => {
					if (res.data.code == 200 || res.data.code == '200') {
						this.authlist = res.data.data.auth
					}

				})
			},
            //复制二维码
			copy() {
				this.$message({
					type: 'success',
					message: '复制成功!'
				});
			},
            handleCommand() {
				this.open1()
            },
            open1() {
				var that = this;
				that.$confirm('确定要退出登录吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loginout()
				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消'
					});
				});
            },
            	loginout() {
				let that = this
				that.$axios.post(that.url + "service/account/loginout", '', {
					headers: {
						admin: window.sessionStorage.getItem('admin')
					}
				}).then(res => {
					if (res.data.code == 200 || res.data.code == '200') {
						//window.localStorage.clear(); //清空所有本地缓存
						window.sessionStorage.clear();
						window.location.reload();
					} else {
						//window.localStorage.clear(); //清空所有本地缓存
						window.sessionStorage.clear();
						window.location.reload();
					}
				})
			},
			course(val){
				// console.log(val);
				this.coursename = val;
			},
			spec(val){
				this.specname = val;
			},
			class(val){
				this.classname = val;
			}
		},
		mounted() {
			Bus.$on("emitObj", this.getObj); //接收数组]
			Bus.$on("chen_coursename", this.course); //接收数组]
			Bus.$on('chen_specname',this.spec); //小节名称
			Bus.$on('chen_classname',this.class); //阶段名称
			// classname
            this.link() 
			this.operateMenu();
			// console.log(this.coursename);
			// if(sessionStorage.getItem('chen_coursename')){
			// 	this.coursename = sessionStorage.getItem('chen_coursename');
			// }
		},
		created() {
			this.getBreadcrumb();
		},
		watch: {
			//监听路由
			$route() {
				this.getBreadcrumb();
			}
		},
	}
</script>
<style scoped>
	.headerleft .itemspan{
		display: block;
		max-width: 300px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.headers {
		width: calc(100% - 190px);
		min-width: 1200px;
		height: 55px;
		position: fixed;
		top: 0;
		left: 190px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		cursor: pointer;
		background-color: #ffffff;
		z-index: 99;
	}
    .headerleft{
        min-width: 300px;
		/* width: 800px; */
        height: 55px;
        float: left;
		overflow: hidden;
		/* text-overflow: ellipsis;
		white-space: nowrap; */
    }
   .headerleft .el-breadcrumb {
		line-height: 55px;
		padding-left: 30px;
		color: #909399;
		font-size: 14px;
	}

	.headerleft .el-breadcrumb span,
	.headerleft .el-breadcrumb a {
		color: #909399 !important;
	}

	.headerleft>>>.el-breadcrumb__item:last-child .el-breadcrumb__inner {
		color: #409eff !important;
		cursor: pointer;
	}
   .headerright {
		float: right;
        padding-right: 20px;
	}
    .input-one {
		position: relative;
        float: left;
	}
    .input-one {
		width: 219px;
		height: 30px;
        margin-top: 12px;
	}
    >>>.el-input__inner {
		border-radius: 20px;
	}
	.input-one img {
		position: absolute;
		right: 1px;
		top: 1px;
	}
    .shugang {
		width: 1px;
		height: 20px;
		display: block;
		background-color: #dcdfe6;
		float: left;
		margin: 17px 24px;
	}
    .input-two{
        float: left;
        margin-top: 12px;
        position: relative;
        float: left;
        width: 80px;
        height: 55px;
    }
    .erweima{
       width: 120px; 
       height: 160px;
       position: absolute;
       left: -18px;
       z-index:666;
       top:43px;
       background-color: #ffffff;
       display: none;
       box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    }
    .saoyisao{
        font-size: 14px;
        text-align: center;
        width: 120px;
        height: 14px;
        display: block;
    }
    .erwei{
        margin-top: 10px;
        margin-left: 10px;
    }
    .fuzu{
        color: #409eff;
        font-size: 14px;
        width: 120px;
        text-align: center;
        height: 14px;
        display: block;
    }
    .input-two:hover .erweima{
        display: block;
    }
    .tongzhicenter{
        width: 75px;
        height: 55px;
        float: left;
        position: relative;
    }
    .tonmain{
       width: 75px;
       height: 55px;
       display: flex;
       align-items: center;
       font-size: 14px;
    }
    .tongzhilist{
        position: absolute;
        top: 55px;
        width: 100px;
        height: 85px;
        background-color: #fff;
        z-index: 66;
        left: -15px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        display: none;
    }
    .tongzhilist button{
        border: none;
        width: 100px;
        height: 40px;
        display: block;
    }
     .tongzhilist button:nth-of-type(2){
         margin-left: 0px;
     }
     .tongzhicenter:hover .tongzhilist{
         display: block;
     }
     .person{
         min-width: 120px;
         float: left;
         height: 55px;
         font-size: 14px;
        position: relative;
     }
     .person-one img{
        width: 30px;
        height: 30px;
        display: block;
        margin-right: 10px;
     }
     .person-one{
        display: flex;
        align-items: center;
        height: 55px;
     }
     .tuideng{
         position: absolute;
        top: 55px;
        width: 120px;
        height: 40px;
        background-color: #fff;
        z-index: 66;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        text-align: center;
        line-height: 40px;
        display: none;
     }
     .person:hover .tuideng{
         display: block;
     }
     .shugangmain{
		 margin-left: 10px;
	 }

	>>>.el-button {
		color: #909399;
	}

	>>>.el-card.is-always-shadow {
		-webkit-box-shadow: 0 0 0 0 #fff;
		box-shadow: 0 0 0 0 #fff;
	}

	>>>.el-card.is-hover-shadow:focus {
		-webkit-box-shadow: 0 0 0 0 #fff;
		box-shadow: 0 0 0 0 #fff;
	}

	>>>.el-card.is-hover-shadow:hover {
		-webkit-box-shadow: 0 0 0 0 #fff;
		box-shadow: 0 0 0 0 #fff;
	}

	>>>.el-card {
		border: 1px solid #fff;
		background-color: #fff;
		color: #303133;
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}

	>>>.el-breadcrumb__inner {}

	>>>.is-link {
		text-decoration: none;
		-webkit-transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(144, 147, 153, 1);
		line-height: 15px;
	}

	>>>.el-breadcrumb__separator {
		margin: 0 9px;
		font-weight: 400;
		color: #c0c4cc;
	}

</style>



// WEBPACK FOOTER //
// src/components/comment/header.vue